import React, { useEffect, useState, useGlobal } from "reactn";
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Input, Button, Card, message, Select } from 'antd';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { ImageUrl } from '../components';
import { Link } from 'react-router-dom';
import { useCallback } from "react";
import { doc, getDoc, setDoc, addDoc, collection } from "firebase/firestore";
import firebaseDb, { auth } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { nanoid } from 'nanoid';

const UsersDetail = (props) => {
    let params = useParams()
    let history = useHistory()
    let id = params.id !== "add" ? params.id : false;

    let newRecord = {
        uuid: nanoid(23),
        role: "admin",
        name: '',
        surname: null,
        profileImageUrl: null,
    }

    let [data, setData] = useState(id ? [] : newRecord);
    let [errors, setErrors] = useState([]);
    let [loading, setLoading] = useState(id ? true : false);
    let [validationCheck, setValidationCheck] = useState(false)

    //onetime run
    useEffect(() => {
        if (id) {
            setLoading(true)
            get()
        }
    }, [id]);

    let get = async () => {
        const userRef = doc(firebaseDb, "users", id);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
            setData({
                ...userSnap.data(),
                id: userSnap.id
            });
            setLoading(false)
        }
    }
    let validate = useCallback(() => {
        let errors = {};
        if (data.name === null || data.name.length === 0)
            errors.name = 'Zorunlu Alan!'

        errors.all = Object.getOwnPropertyNames(errors).map(n => errors[n]);
        errors.hasError = errors.all.length > 0;
        return errors;
    }, [data]);

    useEffect(() => { if (validationCheck) setErrors(validate()) }, [validationCheck, data, validate]);

    let save = async () => {
        setValidationCheck(true)
        let err = validate()
        if (err.hasError) {
            setErrors(err)
            window.scrollTo({ top: 20, behavior: 'smooth' });
        }
        else {
            if (id) {
                console.log({ id });
                await setDoc(doc(firebaseDb, "users", id), { ...data });
                message.success("Bilgiler güncellendi", 2);
                history.push('/admins')

            } else {
                await createUserWithEmailAndPassword(auth, data.email, data.password).then(async (userCredential) => {
                    await addDoc(collection(firebaseDb, "users"), { ...data, uuid: userCredential.user.uid });
                }).catch((e) => {
                    console.log(e);
                })
                message.success("Admin Eklendi", 2);
                history.push('/admins')

            }

        }
    };

    const { Option } = Select;

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Kullanıcılar"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/admins">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="form-wrap">
                <Card title={id ? "Düzenle" : "Ekle"} loading={loading}>
                    <Form layout="horizontal" size={"large"} onFinish={save}>
                        <Row direction="row">
                            <Col span={12}>
                                <Form.Item label="Avatar" help={errors.profileImageUrl} validateStatus={errors.profileImageUrl ? 'error' : 'success'}>
                                    <ImageUrl className="button4" record={data} setRecord={setData} name="profileImageUrl" fileName="user" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Rol" required help={errors.role} validateStatus={errors.role ? 'error' : 'success'}>
                                    <Select defaultValue={(data.role) ? data.role : 'user'} style={{ width: 120 }} onChange={v => { setData({ ...data, role: v }) }}>
                                        <Option value="user">User</Option>
                                        < Option value="admin">Admin</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="İsim" required help={errors.name} validateStatus={errors.name ? 'error' : 'success'}>
                                    <Input className="button4" name="name" value={data.name} onChange={e => setData({ ...data, name: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Soyadı" help={errors.surname} validateStatus={errors.surname ? 'error' : 'success'}>
                                    <Input className="button4" name="surname" value={data.surname} onChange={e => setData({ ...data, surname: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Email" help={errors.email} validateStatus={errors.email ? 'error' : 'success'}>
                                    <Input className="button4" name="email" value={data.email} onChange={e => setData({ ...data, email: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Parola" help={errors.password} validateStatus={errors.password ? 'error' : 'success'}>
                                    <Input className="button4" name="password" value={data.password} onChange={e => setData({ ...data, password: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col span={24}>
                                <Form.Item>
                                    <Button className="button4" type="primary" disabled={loading} htmlType="submit" size="large" block > KAYDET </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default UsersDetail;
